import i18next from 'i18next'
import * as ReactI18next from 'react-i18next'
import { SUPPORTED_LANGUAGES, resolveLanguage } from './language'
import en from './locales/en.json'
import ru from './locales/ru.json'
import es from './locales/es.json'
import type { SupportedLanguage } from './language'

export type { SupportedLanguage } from './language'
export {
  SUPPORTED_LANGUAGES,
  resolveLanguage,
  apiLanguageToUi,
  uiLanguageToApi,
  browserLocaleToLanguage,
} from './language'

function getInitialLanguage(): SupportedLanguage {
  const browserLocale =
    typeof navigator !== 'undefined' ? navigator.language : 'en'

  return resolveLanguage({ apiLanguage: null, browserLocale })
}

const i18n = i18next.createInstance()

i18n.use(ReactI18next.initReactI18next)

i18n.init({
  resources: {
    en,
    ru,
    es,
  },
  lng: getInitialLanguage(),
  fallbackLng: 'en',
  supportedLngs: [...SUPPORTED_LANGUAGES],
  defaultNS: 'common',
  ns: [
    'common',
    'auth',
    'shell',
    'workspacePlan',
    'workspacePage',
    'workspacePresence',
    'workspace',
    'documentCollections',
    'profile',
    'pages',
    'table',
    'team',
    'documentRecords',
    'documentFields',
    'imports',
    'dashboard',
    'aiChat',
    'aiUsage',
    'mcp',
    'history',
    'theme',
    'generalSettings',
    'billing',
    'receipts',
    'operator',
    'legal',
    'communications',
    'documentPreview',
  ],
  interpolation: {
    escapeValue: false,
  },
  returnObjects: false,
  returnNull: false,
})

export default i18n
